@if (isElementAllowed()) {
  @let navElement = element();

  @if (navElement.route) {
    <a
      mat-list-item
      (click)="panel.toggle()"
      routerLinkActive="selected"
      [routerLinkActiveOptions]="routerLinkActiveOptions()"
      class="element side-nav-link"
      id="{{ navElement.name }}"
      [ngStyle]="{ 'padding-left': padding() }"
      [routerLink]="navElement.route"
      [queryParams]="navElement.queryParams">
      @if (navElement.isSvgIcon) {
        @if (navElement.icon) {
          <mat-icon matListItemIcon class="align-middle" [svgIcon]="navElement.icon"></mat-icon>
        }
      } @else if (navElement.icon) {
        <mat-icon matListItemIcon class="align-middle">{{ navElement.icon }}</mat-icon>
      }
      <span [class.header-item]="!!navElement.elements && !navElement.icon">{{
        navElement.name | translate: locale.language
      }}</span>
      <span style="flex: auto"></span>
    </a>
  }

  @if (!navElement.route) {
    <mat-list-item
      (click)="panel.toggle()"
      class="element"
      id="{{ navElement.name }}"
      [ngStyle]="{ 'padding-left': padding() }"
      matTooltip="Click to expand {{ navElement.name | translate: locale.language }}"
      [matTooltipDisabled]="!(!panel.expanded && !!navElement.elements)"
      matTooltipPosition="after"
      (keypress.enter)="panel.toggle()"
      (keydown.space)="$event.preventDefault(); panel.toggle()">
      @if (navElement.isSvgIcon && navElement.icon) {
        <mat-icon matListItemIcon class="align-middle" [svgIcon]="navElement.icon"></mat-icon>
      } @else if (navElement.icon) {
        <mat-icon matListItemIcon class="align-middle">{{ navElement.icon }}</mat-icon>
      }
      <span matListItemTitle [class.header-item]="!!navElement.elements && !navElement.icon">{{
        navElement.name | translate: locale.language
      }}</span>
      <span style="flex: auto"></span>
      <span matListItemMeta>
        @if (navElement.elements?.length) {
          <button
            mat-icon-button
            [attr.aria-label]="
              (panel.expanded ? 'Collapse ' : 'Expand ') + (navElement.name | translate: locale.language)
            ">
            <mat-icon>{{ panel.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
          </button>
        }
      </span>
    </mat-list-item>
  }

  <div [class.hidden]="!navElement.elements?.length" [class.nested]="nested()">
    <mat-expansion-panel
      #panel="matExpansionPanel"
      [class.hidden]="!navElement.elements?.length"
      class="mat-elevation-z0"
      [expanded]="navElement.expanded != null && !isInRoute() ? navElement.expanded : true">
      <div *ngIf="!!navElement.elements">
        <app-nav-element
          [nested]="nested()"
          *ngFor="let ele of navElement.elements"
          [element]="ele"
          [level]="level() + 1">
        </app-nav-element>
      </div>
    </mat-expansion-panel>
  </div>
}
